<template>
  <div class="classify">
    <div class="image-region" :class="{flip: flipStatus}">
      <!-- 分类图片容器 -->
      <div class="img-container classify-container" v-if="subtopicInfo.t_mode * 1 === 1 && groupList.length > 0">
        <div class="container-item" :class="{empty: item.selectedItems.length === 0, demo: item.demo}" :style="`background-image: url(${item.demo});`" v-for="item in groupList" :key="item.groupIndex" @click="classifyClick(item)">
          <img v-if="item.selectedItems.length > 0" :src="item.selectedItems[item.selectedItems.length - 1].img_url" alt=""></img>
        </div>
      </div>
      <!-- 排序图片容器 -->
      <div class="img-container sort-container" v-if="subtopicInfo.t_mode * 1 === 2">
        <div class="container-item" :class="{empty: !item}" v-for="(item, index) in sortedItems" :key="index" @click="sortContainerClick(item, index)">
          <img v-if="item" :src="item.img_url" alt="">
        </div>
      </div>
      <!-- 测试图片 -->
      <div class="img-list" :class="`num${testImages.length}`">
        <div class="img-item" :class="{active: selectedTestItem && selectedTestItem.index * 1 === item.index * 1,selected: getSelectedStatus(item)}" v-for="(item, index) in testImages" :key="`test${index}`" @click="testSelect(item)">
          <img :src="item.img_url" alt=""></img>
        </div>
      </div>
    </div>
    <div class="flip-btn" @click="flip">
      <img src="@/assets/img/btn-flip.png" alt="">
    </div>
    <!-- 预览按钮 -->
    <div class="preview-btn" v-if="subtopicInfo.t_mode * 1 === 1" @click="previewShow = true">预览</div>
    <!-- 预览弹窗 -->
    <van-popup class="preview-modal" v-if="previewShow" v-model="previewShow" :close-on-click-overlay="false">
      <div class="container">
        <div class="content">
          <div class="group-list">
            <div class="group-list-item" v-for="(item, index) in groupList" :key="index">
              <div class="image demo" :class="{empty: !item.demo}">
                <img :src="item.demo" v-if="item.demo" alt="">
              </div>
              <!-- 选中项列表区域 -->
              <div class="selected-list-wrapper" v-if="item.selectedItems.length > 0">
                <div class="scroll-btn left" v-if="item.isOverflow && item.selectedItems.length > 0" @click="scrollList(index, 'left')">
                  <img src="@/assets/img/btn-prev.png" alt=""></img>
                </div>

                <div class="selected-list">
                  <div class="selected-items">
                    <div class="selected-item image" v-for="(selected, idx) in item.selectedItems" :key="`list${idx}`">
                      <img :src="selected.img_url" alt="">
                    </div>
                  </div>
                </div>

                <div class="scroll-btn right" v-if="item.isOverflow && item.selectedItems.length > 0" @click="scrollList(index, 'right')">
                  <img src="@/assets/img/btn-next.png" alt=""></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="close-btn" @click="previewShow = false">×</div>
    </van-popup>
  </div>
  </div>
</template>

<script>
export default {
  name: "classify",
  props: {
    value: {
      type: [Number, String],
      default: ""
    },
    subtopicInfo: {
      type: Object,
      required: true
    },
    originalSubtopicInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      flipStatus: false,
      answer: "",
      answerRecord: [],
      groupList: [],
      testImages: [],
      sortedItems: [],
      loading: false,
      selectedTestItem: null,
      previewShow: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.answer = val;
      },
      immediate: true
    },
    subtopicInfo: {
      handler(val) {
        if (this.originalSubtopicInfo.is_rec * 1 === 1) {
          this.answer = this.originalSubtopicInfo.rec_answer * 1;
          this.$emit('input', this.answer);
          this.$set(this, 'answerRecord', this.originalSubtopicInfo.rec_option);
        }
        if (val.t_mode * 1 === 1) {
          this.$nextTick(() => {
            this.processGroupImages();
          })
        }
        if (val.t_mode * 1 === 2) {
          this.$nextTick(() => {
            this.processSortMode();
          });
        }
      },
      immediate: true
    },
    previewShow(newVal) {
      if (newVal) this.checkOverflow();
    }
  },
  methods: {
    processGroupImages() {
      if (this.subtopicInfo.t_mode * 1 !== 1) return;

      let globalIndex = 0; // 全局非示范图索引计数器（从1开始）

      // 处理每个分组
      this.groupList = this.subtopicInfo.g_img.map((group, groupIndex) => {
        let demoItem = group.find(item => item.is_exam * 1 === 1);
        const groupNonDemo = group.filter(item => item.is_exam * 1 !== 1);

        // 为非示范图添加分组索引和全局索引
        groupNonDemo.forEach((item, idx) => {
          item.groupIndex = groupIndex;
          item.index = globalIndex++;
        });

        return {
          demo: demoItem ? demoItem.img_url : '',
          list: groupNonDemo,
          selectedItems: [],
          groupIndex,
          isOverflow: false
        };
      });

      // 收集所有非示范图并打乱顺序
      this.testImages = this.shuffleArray([
        ...this.groupList.reduce((acc, curr) => acc.concat(curr.list), [])
      ]);

      // 同步答题记录到 groupList
      if (this.originalSubtopicInfo.is_rec * 1 === 1 && this.answerRecord.length > 0) {
        this.answerRecord.forEach(record => {
          const group = this.groupList.find(g => g.groupIndex * 1 === record.groupIndex * 1);
          if (group) {
            group.selectedItems = [...record.items]; // 同步选中项
          }
        });
      }
    },
    processSortMode() {
      // 初始化排序容器数量
      this.sortedItems = new Array(this.subtopicInfo.serial.length).fill(null);

      if (this.originalSubtopicInfo.is_rec * 1 === 1 && this.answerRecord.length > 0) {
        this.answerRecord.forEach((record, index) => {
          if (record.item) {
            this.$set(this.sortedItems, index, { ...record.item }); // 同步排序项
          }
        });
      }

      // 合并并打乱测试图片
      const combined = [...this.subtopicInfo.serial, ...this.subtopicInfo.noise.map((item, index) => {
        return { ...item, index: this.subtopicInfo.serial.length + index };
      })];
      this.testImages = this.shuffleArray(combined);
    },
    // 随机打乱数组
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    flip() {
      this.flipStatus = !this.flipStatus
    },
    testSelect(item) {
      if (this.loading) return;
      let flag = this.getSelectedStatus(item);
      if (flag) {
        this.loading = false;
        return;
      }
      if (this.subtopicInfo.t_mode * 1 === 1) {
        this.selectedTestItem = this.selectedTestItem && this.selectedTestItem.index * 1 === item.index * 1 ? null : item;
      } else {
        this.loading = true;
        // 查找第一个空容器
        const emptyIndex = this.sortedItems.findIndex(i => i === null);
        if (emptyIndex === -1) {
          this.loading = false;
          return
        };

        // 执行动画
        const testIndex = this.testImages.findIndex(img => img.index * 1 === item.index * 1);
        if (testIndex === -1) {
          this.loading = false;
          return;
        }
        const containerElement = this.$el.querySelectorAll('.sort-container .container-item')[emptyIndex];
        const testElement = this.$el.querySelectorAll('.img-list .img-item')[testIndex];

        this.startAnimation(testElement, containerElement, item.img_url, () => {
          // 数据处理
          this.$set(this.sortedItems, emptyIndex, { ...item });
          this.loading = false;
          this.updateAnswerRecord();
        });
      }
    },
    classifyClick(group) {
      if (this.loading || !group) return;
      this.loading = true;

      if (this.selectedTestItem) {
        this.addItemToGroup(group);  // 添加图片到分类
      } else {
        this.removeItemFromGroup(group);  // 移除分类最后一张图
      }
    },
    addItemToGroup(group) {
      const item = this.selectedTestItem;
      const testIndex = this.testImages.findIndex(img => img.index * 1 === item.index * 1);
      if (testIndex === -1) {
        this.loading = false;
        return;
      }

      // 获取DOM元素
      const testElement = this.$el.querySelectorAll('.img-list .img-item')[testIndex];
      const exampleElement = this.$el.querySelectorAll('.classify-container .container-item')[group.groupIndex];

      // 执行动画
      this.startAnimation(testElement, exampleElement, item.img_url, () => {
        // 数据处理
        group.selectedItems.push(item);
        this.selectedTestItem = null;
        this.loading = false;
        this.updateAnswerRecord();
      });
    },
    removeItemFromGroup(group) {
      if (group.selectedItems.length === 0) {
        this.loading = false;
        return;
      }

      const item = group.selectedItems.pop();

      // 获取DOM元素
      const exampleElement = this.$el.querySelectorAll('.classify-container .container-item')[group.groupIndex];
      const testIndex = this.testImages.findIndex(img => img.index * 1 === item.index * 1);
      if (testIndex === -1) {
        this.loading = false;
        return;
      }
      const testElement = this.$el.querySelectorAll('.img-list .img-item')[testIndex];

      // 执行动画
      this.startAnimation(exampleElement, testElement, item.img_url, () => {
        this.loading = false;
        this.updateAnswerRecord();
      });
    },
    sortContainerClick(item, index) {
      if (this.loading || !item) return;
      this.loading = true;

      // 获取DOM元素
      const containerElement = this.$el.querySelectorAll('.sort-container .container-item')[index];
      const testIndex = this.testImages.findIndex(img => img.index * 1 === item.index * 1);
      if (testIndex === -1) {
        this.loading = false;
        return;
      }
      const testElement = this.$el.querySelectorAll('.img-list .img-item')[testIndex];

      // 执行动画
      this.startAnimation(containerElement, testElement, item.img_url, () => {
        // 数据处理
        this.$set(this.sortedItems, index, null);
        this.loading = false;
        this.updateAnswerRecord();
      });
    },
    startAnimation(startEl, endEl, imgUrl, callback) {
      if (!startEl || !endEl) return;

      const container = endEl.closest('.image-region');
      const containerTransform = getComputedStyle(container).transform;
      const startRect = startEl.getBoundingClientRect();
      const endRect = endEl.getBoundingClientRect();

      // 创建克隆元素
      const clone = document.createElement('img');
      clone.src = imgUrl;
      clone.style.position = 'absolute';
      clone.style.left = `${startRect.left}px`;
      clone.style.top = `${startRect.top}px`;
      clone.style.width = `${endEl.offsetWidth}px`;
      clone.style.height = `${endEl.offsetHeight}px`;
      clone.style.borderRadius = '0.15rem';
      clone.style.objectFit = 'cover';
      clone.style.transition = 'all 0.5s ease';
      clone.style.zIndex = '1000';
      clone.style.transform = containerTransform;
      document.body.appendChild(clone);

      // 触发重绘
      void clone.offsetWidth;

      // 移动到目标位置
      clone.style.left = `${endRect.left}px`;
      clone.style.top = `${endRect.top}px`;

      // 动画结束后执行回调
      const handleTransitionEnd = () => {
        clone.removeEventListener('transitionend', handleTransitionEnd);
        clone.remove();
        if (callback) callback();
      };

      clone.addEventListener('transitionend', handleTransitionEnd);
    },
    updateAnswerRecord() {
      if (this.subtopicInfo.t_mode * 1 === 1) {
        this.answerRecord = this.groupList.map(group => ({
          groupIndex: group.groupIndex,
          items: group.selectedItems.map(item => ({ ...item }))
        }));
      } else {
        this.answerRecord = this.sortedItems.map(item => ({ item }));
      }

      // 计算得分
      this.calculateAnswer();
    },
    getSelectedStatus(item) {
      // 查找所有分组的选中项中是否包含当前项
      if (this.subtopicInfo.t_mode * 1 === 1) {
        return this.answerRecord.some(group =>
          group.items.some(i => i.index * 1 === item.index * 1)
        );
      } else {
        return this.answerRecord.some(e => e.item && e.item.index * 1 === item.index * 1);
      }
    },
    // 计算分数
    calculateAnswer() {
      if (this.subtopicInfo.t_mode * 1 === 1) {
        let flag = this.answerRecord.every(v => v.items.length === 0);
        if (flag) {
          this.answer = '';
        } else {
          let allCorrect = true;

          // 检查每个分类的选中状态
          for (let i = 0; i < this.groupList.length; i++) {
            const currentGroup = this.groupList[i];
            const selectedItems = currentGroup.selectedItems;

            // 检查1：必须包含至少一张图片
            if (selectedItems.length === 0) {
              allCorrect = false;
              break;
            }

            // 检查2：所有选中图片必须来自同一原始组
            const sourceGroupIndex = selectedItems[0].groupIndex;
            const allFromSameGroup = selectedItems.every(
              item => item.groupIndex * 1 === sourceGroupIndex * 1
            );

            if (!allFromSameGroup) {
              allCorrect = false;
              break;
            }

            // 获取原始组数据
            const sourceGroup = this.groupList[sourceGroupIndex];

            // 检查3：选中数量必须与原始组相同
            if (selectedItems.length !== sourceGroup.list.length) {
              allCorrect = false;
              break;
            }

            // 检查4：必须包含原始组的所有图片
            const selectedIndices = selectedItems.map(item => item.index * 1);
            const sourceIndices = sourceGroup.list.map(item => item.index * 1);

            if (!this.arraysEqual(selectedIndices.sort(), sourceIndices.sort())) {
              allCorrect = false;
              break;
            }

            // 特殊检查：如果当前分类有示范图
            if (currentGroup.demo) {
              // 检查5：必须选中该分类对应原始组的图片
              if (sourceGroupIndex !== i) {
                allCorrect = false;
                break;
              }
            }
          }

          // 检查6：所有原始组的图片必须被分配到正确的分类
          if (allCorrect) {
            allCorrect = this.checkAllGroupsAssigned();
          }

          this.answer = allCorrect ? 1 : 0;
        }
      }
      if (this.subtopicInfo.t_mode * 1 === 2) {
        const hasStarted = this.sortedItems.some(item => item !== null);

        if (!hasStarted) {
          this.answer = "";
        } else {
          let allCorrect = true;

          for (let i = 0; i < this.sortedItems.length; i++) {
            const sortedItem = this.sortedItems[i];
            const serialItem = this.subtopicInfo.serial[i];

            if (!sortedItem || sortedItem.index * 1 !== serialItem.index * 1) {
              allCorrect = false;
              break;
            }
          }

          this.answer = allCorrect ? 1 : 0;
        }
      }
      this.$emit('input', this.answer);
    },
    // 检查数组是否相等
    arraysEqual(a, b) {
      if (a.length !== b.length) return false;
      return a.every((val, index) => val === b[index]);
    },

    // 检查所有原始组的图片是否被正确分配
    checkAllGroupsAssigned() {
      for (const group of this.groupList) {
        const assignedTo = this.groupList.find(g =>
          g.selectedItems.some(item =>
            item.groupIndex * 1 === group.groupIndex * 1
          )
        );
        // 如果有示范图，必须分配到对应分类
        if (group.demo) {
          if (!assignedTo || assignedTo.groupIndex * 1 !== group.groupIndex * 1) {
            return false;
          }
        } else {
          // 无示范图的组必须被分配到某个分类
          if (!assignedTo) {
            return false;
          }
        }
      }
      return true;
    },
    checkOverflow() {
      this.$nextTick(() => {
        const containers = this.$el.querySelectorAll('.selected-items');
        containers.forEach((container, index) => {
          const isOverflow = container.scrollWidth > container.clientWidth;
          this.$set(this.groupList[index], 'isOverflow', isOverflow);
        });
      });
    },
    scrollList(groupIndex, direction) {
      const container = this.$el.querySelectorAll('.selected-items')[groupIndex];
      // 获取容器的宽度
      const containerWidth = container.offsetWidth;
      const scrollAmount = direction === 'left' ? -containerWidth : containerWidth;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    },
  },
}
</script>

<style lang="less" scoped>
.classify {
  width: 100%;
  height: 100%;
  position: relative;
  .image-region {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    &.flip {
      transform: rotate(180deg);
    }
  }
  .img-container {
    width: 100%;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    .container-item {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 0.15rem;
      overflow: hidden;
      font-size: 0;
      margin: 0.05rem;
      border: 0.01rem solid #ffc2b0;
      &.empty {
        background: #fff;
      }
      &.demo {
        background-position: center;
        background-size: cover;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .selected img {
      display: none;
    }
  }
  .img-list {
    width: 100%;
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
    position: relative;
    .img-item {
      width: 1rem;
      height: 1rem;
      border-radius: 0.15rem;
      overflow: hidden;
      font-size: 0;
      margin: 0 0.15rem;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .active {
      border: 0.02rem dashed #ffb453;
    }
    .selected img {
      display: none;
    }
    &.num6 .img-item,
    &.num7 .img-item,
    &.num8 .img-item,
    &.num9 .img-item,
    &.num10 .img-item {
      margin: 0 0.1rem 0.2rem;
    }
    &.num6 {
      width: 4rem;
      .img-item:nth-child(n + 4) {
        margin-bottom: 0;
      }
    }
    &.num7,
    &.num8 {
      width: 5rem;
      .img-item:nth-child(n + 5) {
        margin-bottom: 0;
      }
    }
    &.num9,
    &.num10 {
      width: 6rem;
      .img-item:nth-child(n + 6) {
        margin-bottom: 0;
      }
    }
  }
  .flip-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.28rem;
    height: 0.28rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .preview-btn {
    width: 0.5rem;
    height: 0.3rem;
    background: #ffe37d;
    box-shadow: 0 0.03rem 0.06rem 1px #ffcb0e,
      inset 0 0.03rem 0.06rem 1px #ff845a;
    border-radius: 0 0.2rem 0.2rem 0;
    line-height: 0.3rem;
    font-size: 0.12rem;
    font-weight: bold;
    text-align: center;
    color: #630200;
    position: absolute;
    left: -0.1rem;
    top: 0.1rem;
  }
}
.preview-modal {
  width: 70%;
  overflow: unset;
  background: none;
  .container {
    display: flex;
    max-height: 90vh;
    background: linear-gradient(180deg, #fed39e 0%, #f6c28a 100%);
    box-shadow: 0px 0px 0.1rem 1px #97562a;
    border-radius: 0.25rem;
    padding: 0.1rem;
    position: relative;
    z-index: 9999;
  }
  .content {
    flex: 1;
    background: #fff;
    box-shadow: 0px 0px 0.1rem 1px #c14d00;
    border-radius: 0.2rem;
    padding: 0.2rem;
    overflow: hidden;
    .group-list {
      height: 100%;
      overflow-y: scroll;
      border-radius: 0.2rem;
    }
    .group-list-item {
      display: flex;
      margin-bottom: 0.16rem;
      background: #fff1e1;
      border-radius: 0.12rem;
      overflow: hidden;
      padding: 0.15rem 0.1rem 0.15rem 0.15rem;
      .image {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.1rem;
        overflow: hidden;
        margin-right: 0.12rem;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &.empty {
          background: #fff;
          border: 1px dashed #ffc2b0;
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      .demo {
        flex-shrink: 0;
        margin-right: 0.08rem;
      }
      .selected-list-wrapper {
        flex: 1;
        position: relative;
        overflow: hidden;
      }

      .selected-list {
        width: 100%;
        overflow: hidden;
        padding: 0 0.1rem;
      }

      .selected-items {
        display: flex;
        overflow: hidden;
      }

      .scroll-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          height: 100%;
        }

        &.left {
          left: 0;
        }

        &.right {
          right: 0;
        }
      }
    }
  }
  .close-btn {
    position: absolute;
    right: -0.28rem;
    top: 0.4rem;
    width: 0.3rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    background: #ffaa20;
    box-shadow: 0 0 0.1rem 1px rgba(210, 92, 13, 0.78);
    border-radius: 0 0.4rem 0.4rem 0;
    font-size: 0.2rem;
    color: #630200;
    cursor: pointer;
    z-index: 9998;
  }
}
</style>